module.exports = __webpack_public_path__ + "19e610184e64290115af4f7672ba0b25.png";